module.exports = __webpack_public_path__ + "static/media/icons.7a894b34.webp";